import { TealiumBaseEvent } from './TealiumBaseEvent';

export class TealiumSearchEvent extends TealiumBaseEvent {
  static readonly SEARCH_EVENT = 'search_suggestive_click';

  constructor(searchValue: string, windowLocationHref: string, searchCategorie: string) {
    super(TealiumSearchEvent.SEARCH_EVENT,
    "content interaction",
    TealiumSearchEvent.SEARCH_EVENT);
    this.setEventValue({
      onsiteSearch_searchType: "suggestive",
      page_attributes_currency: "CHF",
      onsiteSearch_searchTerm: searchValue,
      page_attributes_URL: windowLocationHref,
      onsiteSearch_category: searchCategorie,
    });
    delete this.eventValues.event_label;
    delete this.eventValues.product_list_name;
  }
}
